import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';

@Component({
	selector: 'app-sidebar',
	standalone: true,
	imports: [ButtonModule, Tooltip],
	templateUrl: './sidebar.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './sidebar.css',
})
export class SidebarComponent {
	@Input() visible: boolean = true;
	@Output() visibleChange = new EventEmitter<boolean>();

	toggle() {
		this.visible = !this.visible;
		this.visibleChange.emit(this.visible);
	}
}